import { render } from "./ReviewLearnosityApplication.vue?vue&type=template&id=5b01a754"
import script from "./ReviewLearnosityApplication.vue?vue&type=script&lang=js"
export * from "./ReviewLearnosityApplication.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3233614911/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__